import '../../email';
import '../../header';
import { createRollingText } from '../../rolling-text';

const track = {
    svgId: 'circularRollingTextSvg',
    pathId: 'circularSvgPath',
    textContent: 'Share like a pro',
    numTexts: 8,
    animationDuration: 15,
};
createRollingText(track);

if (module.hot) { module.hot.accept(); }
